import { webappClient } from "../clients";

export async function reportFunnelInit() {
  await webappClient.get("api/funnel_metrics");
}
